import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ModelPortfolio } from '../../Models/Models/Instruments/ModelPortfolio';
import { ModelPortfolioTabType } from '../../Constants/Enums/Domain/ModelPortfolioTabType';

declare var IS_RUNNING_IN_APP_POOL;

export class ModelPortfolioProductClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(portfolioId: number, modelPortfolioTabType: ModelPortfolioTabType, hierarchyId: string, canBeBought: boolean): Promise<ModelPortfolio, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/ModelPortfolioProduct/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { portfolioId: portfolioId, modelPortfolioTabType: modelPortfolioTabType, hierarchyId: hierarchyId, canBeBought: canBeBought }

    return AjaxWrapper.get<ModelPortfolio, any>(url, data);
  }
}

